import { useQuery } from '@tanstack/react-query';
import { useAuthenticatedQueryFn } from '@/hooks/useAuthenticatedQuery';
import { useCapabilities } from '@/hooks/useCapabilities';
import { getHome } from '@/services/home.service';
import { QueryKey } from '@/lib/queryKeys';

export const useHome = () => {
  const getHomeQueryFn = useAuthenticatedQueryFn(getHome);
  const { temporaryGuestBlockForHomePage } = useCapabilities();
  const {
    data: homeData = { insights: {}, favorites: [] },
    isPending: homeIsPending,
    isFetching: homeIsFetching,
    error: homeError,
  } = useQuery({
    queryKey: [QueryKey.Home],
    queryFn: () => getHomeQueryFn({}),
    // For now disable this for guest so they don't get errors if they end up on the home page
    enabled: !temporaryGuestBlockForHomePage,
    refetchOnMount: 'always',
  });

  return {
    homeData,
    homeIsPending,
    homeIsFetching,
    homeError,
  };
};
